export default {
  pt: {
    pageTitle: "Detalhes dos Planos",
    mainTitle: "Sobre os planos",
    understoodButton: "Entendi",
  },

  en: {
    pageTitle: "Plan Details",
    mainTitle: "About the plans",
    understoodButton: "I understand",
  },
}; 